import { Component, Inject, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Metric, Thing } from "../../model";

@Component({
    selector: 'wear-status-widget-element-details-dialog',
    template: require('./wear-status-widget-element-details-dialog.component.html'),
})
export class WearStatusWidgetElementDetailsDialogComponent {

    wearMetric: Metric;
    thing: Thing;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<WearStatusWidgetElementDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.wearMetric = data.wearMetric;
        this.thing = data.thing;
    }

    close(): void {
        this.dialogRef.close(true);
    }
}